'use strict';

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var SvgIcon = require('@mui/material/SvgIcon');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var SvgIcon__default = /*#__PURE__*/_interopDefaultLegacy(SvgIcon);

var Validation = function Validation(props) {
  return /*#__PURE__*/React__default["default"].createElement(SvgIcon__default["default"], _rollupPluginBabelHelpers["extends"]({
    viewBox: "0 0 270 250"
  }, props), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M135 23.6C79 23.6 33.6 69 33.6 125S79 226.4 135 226.4c56 0 101.4-45.4 101.4-101.4S191 23.6 135 23.6zm-15 148.7l-48-43 16.1-18 31.1 27.8 62.4-62 17 17.1-78.6 78.1z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
};
Validation.propTypes = SvgIcon__default["default"].propTypes;

module.exports = Validation;
